import styled, { css } from "styled-components";
import theme from "styled-theming";
import { MEDIA_URL } from "static-content/RelativeUrlHelperFunctions";
import { device } from "../styles/Reset";

const topBarClient = theme("client", {
  bbva: css`
    padding: 8px;
    margin: 0 auto 10px auto;
    border-radius: 0;
    height: 48px;
    @media ${device.laptop} {
      min-height: 40px;
      height: 88px;
    }
  `,
});

const logoClient = theme("client", {
  bbva: css`
    float: none;
    background-size: 67px 20px;
    background-position: center;
    width: 100%;
    @media ${device.laptop} {
      min-width: 150px;
      background-size: 133px 40px;
      background-position: left;
      width: 1176px;
      margin: 0 auto;
    }
  `,
});

const clientButtonsWrapper = theme("badgesLayout", {
  contained: css`
    width: auto;
  `,
});

const feedbackButtonClient = theme.variants("badgesLayout", "variant", {
  feedback: {
    contained: css`
      transform: skew(-5deg);
      border: 1px solid #fff;
      font-weight: normal;
    `,
  },
  recommend: {
    contained: css`
      transform: skew(-5deg);
      background-color: ${(props) => props.theme.themeGlobal.third};
      background-image: url(${MEDIA_URL}/star.svg);
      background-repeat: no-repeat;
      background-position: 3px 5px;
      padding-left: 20px;
      border: 1px solid ${(props) => props.theme.themeGlobal.third};
      border-bottom: 2px solid #ffba22;
      font-weight: normal;
    `,
  },
  register: {
    contained: css`
      transform: skew(-5deg);
      background: ${(props) => props.theme.themeGlobal.secondary};
      border: 1px solid ${(props) => props.theme.themeGlobal.secondary};
      font-weight: normal;
    `,
  },
});

export const Bar = styled.div`
  background: ${(props) => props.theme.themeGlobal.main};
  background: ${(props) => props.theme.themeGlobal.topBarColor};
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1150;
  z-index: 3600;
  text-align: center;
  height: 35px;

  @media ${device.tablet} {
    padding: 0 5% 0 2%;
  }
  @media ${device.laptop} {
    min-height: 40px;
    height: 45px;
  }
  ${topBarClient};
`;
export const ButtonsWrapper = styled.div`
  float: right;
  height: 100%;
  display: inline-block;
  width: 70%;
  padding-top: 4px;
  text-align: right;
  ${clientButtonsWrapper};
  @media only screen and (min-width: 991.98px) {
    text-align: right;
  }
`;
export const LogoWrapper = styled.p`
  background: url(${MEDIA_URL}/branding/logo_light.svg);
  background-repeat: no-repeat;
  background-position: 5px center;
  float: left;
  height: 100%;
  display: inline-block;
  color: #fff;
  height: 100%;
  padding: 8px 0;
  font-size: 11px;
  vertical-align: middle;
  min-width: 65px;
  background-size: 60px;
  min-width: 110px;
  background-size: 100px;
  background-position: 10px center;
  > span {
    display: none;
  }

  @media only screen and (min-width: 1040px) {
    min-width: 130px;
    > span {
      padding-left: 10px;
      display: inline-block;
      position: absolute;
      bottom: 0;
      top: 0;
      max-height: 40px;
      margin: auto;
      line-height: 40px;
      margin-left: 90px;
    }
  }
  ${logoClient};
`;
export const Button = styled.button`
  margin-right: 10px;
  margin-top: 5px;
  height: 70%;
  color: #fff;
  padding: 5px 8px;
  font-weight: bold;
  font-size: 0.8rem;
  min-width: 0;
  ${feedbackButtonClient};

  @media only screen and (min-width: 991.98px) {
    font-size: 10px;
    font-size: 1rem;
    min-width: 70px;
  }
`;
